"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Cpu, BrainCircuit, BookOpen, ArrowRight, Mic, Target, ChartBar, Video } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tracks = [{
  title: "Produção de Vídeo",
  description: "Vídeos estratégicos e cinematográficos para fortalecer sua marca e converter leads em clientes reais.",
  icon: Video,
  link: "/VideoProductionInSaoPauloPage",
  buttonText: "Ver Produções",
  animation: "group-hover:rotate-12 group-hover:scale-110"
}, {
  title: "Estúdio de Podcast",
  description: "Gravação profissional em Pinheiros com infraestrutura de ponta para gerar autoridade e conexão.",
  icon: Mic,
  link: "/PodcastStudioInPinheirosPage",
  buttonText: "Reservar Estúdio",
  animation: "group-hover:scale-110"
}, {
  title: "Tráfego Pago",
  description: "Gestão de anúncios com foco total em aquisição de clientes e ROI para o seu negócio digital.",
  icon: Target,
  link: "/PaidTrafficManagementPage",
  buttonText: "Escalar Vendas",
  animation: "group-hover:-translate-y-1 group-hover:scale-110"
}, {
  title: "Consultoria Digital",
  description: "Direcionamento estratégico para estruturar sua presença online e dominar seu nicho de mercado.",
  icon: BrainCircuit,
  link: "/DigitalPresenceConsultationPage",
  buttonText: "Agendar Mentoria",
  animation: "group-hover:rotate-[-12deg] group-hover:scale-110"
}, {
  title: "Gestão de Conteúdo",
  description: "Planejamento e execução de conteúdo institucional de excelência para marcas que buscam sofisticação.",
  icon: BookOpen,
  link: "/ServicesPage",
  buttonText: "Conhecer Planos",
  animation: "group-hover:scale-110"
}];
export default function CoreIntelligenceTracks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223718" id="serviços-principais" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-chart-4/5 rounded-full blur-3xl pointer-events-none" />

      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 tracking-tight text-foreground">
            Serviços Principais
          </h2>
          <p className="font-default text-muted-foreground max-w-2xl mx-auto text-lg">
            Soluções criativas sob medida para marcas que não aceitam o comum. Transformamos visão em realidade através de design institucional de excelência.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {tracks.map((track, i) => <Card key={i} data-index={i} className="group relative bg-[hsl(0,0%,98%)] backdrop-blur-none border-[hsl(0,0%,90%)] transition-all duration-200 ease-out hover:-translate-y-2 hover:shadow-lg hover:shadow-primary/5 overflow-hidden flex flex-col h-full rounded-[12px]">
              <CardHeader className="pb-4">
                <div className="mb-6 inline-flex p-4 rounded-xl bg-primary/5 text-primary transition-colors duration-500 group-hover:bg-primary/10 w-fit">
                  <track.icon className={`w-8 h-8 stroke-[2px] transition-all duration-500 ease-out ${track.animation}`} />
                </div>
                <CardTitle className="font-default text-2xl font-bold tracking-tight text-foreground">
                  {track.title}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="flex-grow pb-2">
                <CardDescription className="font-default text-base leading-relaxed text-muted-foreground transition-colors duration-300">
                  {track.description}
                </CardDescription>
              </CardContent>

              <CardFooter className="pt-0">
                <div className="w-full grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-500 ease-in-out">
                  <div className="overflow-hidden">
                    <div className="pt-6 translate-y-4 group-hover:translate-y-0 transition-all duration-500 ease-out opacity-0 group-hover:opacity-100">
                      <Button asChild className="w-full group/btn border-primary/20 hover:bg-primary hover:text-primary-foreground transition-all duration-300 rounded-full" variant="outline">
                        <Link to={track.link}>
                          {track.buttonText}
                          <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}